/* =====================================================================
   ar-madesa-neo-quiz.js  —  Quiz NEO (placard) — VERSÃO ARGENTINA

   Adaptado do NEO Brasil. Regra de ouro: RÓTULOS em espanhol argentino,
   `value` enviados à HubSpot vindos do form LATAM 980a0b88.
   As únicas exceções são "Otro formato", a 3ª opção de espaço pronto e
   as 3 faixas de investimento em peso — todas precisam existir na
   propriedade E estar disponíveis no campo do formulário.
   A etapa de saída usa a propriedade LATAM etapa_de_saida_do_quiz_neo_latam,
   com as opções em espanhol (último valor, "Concluído", segue em português).
   ———
   ar-madesa-neo-quiz.js  —  Quiz NEO (guarda-roupa) — formulário próprio
   Replica o mecanismo VALIDADO do entry-modal:
     lê o cookie hubspotutk -> monta context -> POST direto na Forms API.
   Layout 100% do tema; envio nativo do HubSpot (atribuição + workflows).

   Fonte de verdade dos campos: construtor do form 980a0b88
   ("CRM-Formulário LP - NEO (LATAM)"), conferido campo a campo.

   ATUALIZAÇÃO (jul/2026) — 4 mudanças:
   1. CAPTAÇÃO ANTECIPADA DO LEAD: ao AVANÇAR da etapa 1 (nome/e-mail/telefone),
      dispara um POST best-effort na Forms API criando/atualizando o contato
      já com origem_de_cadastro e consentimento — mesmo que a pessoa abandone
      o quiz depois. O envio final (etapa 8) usa o MESMO e-mail e apenas
      atualiza o contato (dedupe nativo da HubSpot).
   2/3. CARD DE CONFIRMAÇÃO POR ETAPA: aparece SOMENTE ao tentar FECHAR (X)
      nas etapas 2 a 8 (reaproveita o conteúdo da etapa atual). Traz:
        • primário (vermelho) -> volta pra pergunta (só fecha o card);
        • "Pular esta pergunta" -> pula SÓ a pergunta atual e segue no form;
        • "Sair do formulário"  -> grava a etapa de saída e fecha.
      Textos por etapa no mapa CARD_COPY abaixo (edite à vontade).
   4. BLOQUEIO DE FECHAMENTO: nas etapas 2 a 8 o X não fecha direto — passa
      pelo card de confirmação. Boas-vindas, etapa 1 e sucesso fecham direto.
   5. REGISTRO DA ETAPA DE SAÍDA: grava na propriedade single-select
      etapa_de_saida_do_quiz_neo o ponto em que a pessoa parou — ao SAIR
      pelo card (etapa atual) OU ao CONCLUIR o formulário ("Concluído").
      IMPORTANTE: essa propriedade precisa existir E estar adicionada como
      CAMPO no form 980a0b88 (senão a Forms API rejeita com 400).

   ATUALIZAÇÃO (set/2026) — item 6:
   6. REDIRECIONAMENTO PARA A PÁGINA DE GRACIAS (pedido de Mídia, para medir
      conversão de lead numa URL própria). Ao CONCLUIR o quiz ou ao SAIR pelo
      botão "Salir del formulario", o usuário é levado para THANKYOU_URL.
      Três cuidados que fazem esse redirect NÃO perder dado:
        • o POST da etapa de saída e o da captação antecipada passaram a usar
          `keepalive: true` — assim sobrevivem à navegação;
        • na conclusão, o redirect ESPERA o upload do arquivo (form+iframe)
          responder, porque navegar com o POST em voo cancela o upload;
        • fechar nas telas de boas-vindas / etapa 1 NÃO redireciona por padrão
          (ainda não existe lead nenhum ali) — controlado por
          REDIRECT_ON_CLOSE_MIN_QI.

   UPLOAD DE ARQUIVO (etapa 3): enviado via um form DEDICADO (só email +
   arquivo_neo), separado do form principal do quiz, pelo endpoint v2
   legado (único que aceita o binário do arquivo direto), disparado por um
   <form>+<iframe> escondidos em vez de fetch — assim não cai no bloqueio
   de CORS (que só afeta fetch/XHR, não POST tradicional de formulário).
   É best-effort: TODO o processo fica protegido por try/catch, então uma
   falha aqui NUNCA impede o envio principal do quiz (v3) de acontecer.

   ATUALIZAÇÃO (upload — listagem + remoção): os arquivos escolhidos passam
   a ser mantidos numa lista própria (uploadFiles), renderizada abaixo do
   controle de upload com nome + tamanho + botão de remover por item. Como
   o <input type="file" multiple> reinicia a seleção a cada escolha (não
   soma automaticamente), o array uploadFiles é quem acumula de verdade;
   a cada mudança (adicionar ou remover), reconstruímos input.files via
   DataTransfer para refletir exatamente o que está na lista.

   ENVIO ÚNICO (sem recarregar): após um envio bem-sucedido, o quiz "lembra"
   disso (flag submitted). Se o usuário abrir o quiz de novo na mesma sessão
   de página, ele vai direto pra tela de sucesso, em vez de recomeçar.
   ===================================================================== */
(function () {
  'use strict';

  // -------------------------------------------------------------------
  // CONFIG
  // -------------------------------------------------------------------
  var PORTAL_ID = '39596724';
  var FORM_ID   = '980a0b88-76e2-41d1-a5a5-e04961a16205';
  var SUBMIT_URL = 'https://api.hsforms.com/submissions/v3/integration/submit/' + PORTAL_ID + '/' + FORM_ID;

  // Form dedicado, só pra receber o arquivo — evita duplicar a conversão do
  // form principal do quiz. Enviado via endpoint v2 legado (único que aceita
  // o binário do arquivo direto), disparado por um <form>+<iframe> escondidos
  // em vez de fetch — assim NÃO cai no bloqueio de CORS (que só afeta
  // fetch/XHR, não POST tradicional de formulário).
  var FILE_FORM_ID           = '55f38d14-a24d-48f3-94a7-b9e774cd2303';
  var FILE_FIELD              = 'arquivo_neo';
  var LEGACY_FILE_UPLOAD_URL  = 'https://forms.hubspot.com/uploads/form/v2/' + PORTAL_ID + '/' + FILE_FORM_ID;
  var MAX_FILE_MB = 100;

  // -------------------------------------------------------------------
  // ITEM 6 — REDIRECIONAMENTO PÓS-QUIZ (Mídia: validação de conversão)
  // -------------------------------------------------------------------
  // Para onde o usuário vai ao CONCLUIR o quiz ou ao SAIR pelo card de
  // desistência.
  // ⚠ Mantenha a URL no MESMO domínio da loja. Um salto entre domínios
  //   (madesa.ar -> madesa.com.ar, por exemplo) reinicia a sessão do GA4 e
  //   não leva o cookie hubspotutk — ou seja, quebra justamente a atribuição
  //   que essa página existe para medir.
  var THANKYOU_URL = 'https://madesa.ar/pages/lp-neo-quiz-gracias';

  // Quanto tempo a tela de éxito fica visível antes de navegar (ms).
  // Serve também de folga para o evento 'mnq:submitted' e as tags de
  // conversão (GA4/Meta) dispararem antes da troca de página.
  var SUCCESS_REDIRECT_DELAY_MS = 1500;

  // Teto de espera pelo upload do arquivo antes de navegar (ms). Navegar com o
  // POST do iframe em andamento CANCELA o upload, então o redirect espera o
  // iframe responder — ou este teto, o que acontecer primeiro.
  var FILE_UPLOAD_WAIT_MS = 12000;

  // A partir de qual etapa (qi, 1-based entre as perguntas) FECHAR o quiz
  // também redireciona:
  //   2 = só quando o lead já existe na HubSpot (a captação antecipada roda ao
  //       AVANÇAR da etapa 1). Boas-vindas e etapa 1 fecham sem redirecionar,
  //       pra não mandar pra página de gracias quem não deixou contato nenhum.
  //   0 = redireciona em QUALQUER fechamento, inclusive na tela inicial.
  var REDIRECT_ON_CLOSE_MIN_QI = 2;

  // Trava de navegação única: impede que dois caminhos (ex.: redirect agendado
  // pelo sucesso + clique em "Seguir navegando") disparem location duas vezes.
  var redirecting = false;
  var redirectTimer = null;

  // delayMs: espera antes de navegar. force: antecipa um redirect já agendado.
  function goToThankYou(delayMs, force) {
    if (redirecting && !force) return;
    if (force && redirectTimer) window.clearTimeout(redirectTimer);
    redirecting = true;
    redirectTimer = window.setTimeout(function () {
      window.location.href = THANKYOU_URL;
    }, delayMs || 0);
  }

  // Trava de envio único do FINAL (dura enquanto a página não recarregar).
  var submitted = false;
  // Item 1: trava da captação antecipada do lead (dispara uma única vez por
  // sessão de página, ao avançar da etapa 1).
  var leadCaptured = false;

  // Campo de data (enviado como epoch ms em UTC meia-noite — igual a Fase 0)
  var DATE_FIELD = 'cuando_piensas_realizar_tu_compra_del_placard_modular_arneo';

  // Etapa 3 — MEDIDAS: no formulário LATAM as paredes deixam de ir em campos
  // separados (parede_1/2/3, que NÃO existem no form 980a0b88) e passam a ser
  // CONCATENADAS num único campo de TEXTO:
  //   "Pared 1: 300 cm | Pared 2: 250 cm"
  // Só entram as paredes visíveis para o formato escolhido E preenchidas.
  var MEASURES_FIELD = 'medidas_del_cuarto_para_el_proyecto_planificado_arneo';

  // Item 5: propriedade que registra em que etapa a pessoa parou.
  // Versão LATAM da propriedade (opções em espanhol), já adicionada como
  // CAMPO no form 980a0b88 (Etapa 7 do construtor).
  var EXIT_FIELD = 'etapa_de_saida_do_quiz_neo_latam';

  // qi (posição 1-based ENTRE as perguntas) -> valor EXATO gravado na
  // propriedade acima. Os textos têm que bater 1:1 com as opções cadastradas
  // na propriedade single-select da HubSpot.
  var EXIT_STEP = {
    2: '2 - Elección del formato',
    3: '3 - Medidas del cuarto',
    4: '4 - Medida de la cama',
    5: '5 - Otros muebles',
    6: '6 - Espacio listo',
    7: '7 - Agendamiento',
    8: '8 - Inversión'
  };

  // Itens 2/3: conteúdo do card de confirmação por etapa (aparece só ao
  // tentar FECHAR nas etapas 2 a 8). Edite os textos livremente — a
  // estrutura (título / subtítulo / rótulo do botão primário) é fixa.
  var CARD_COPY = {
    2: { title: 'Este paso ayuda a dar forma al placard de tus sueños',
         sub:   'Elegir el formato es clave para mostrarte opciones que funcionen en tu espacio.',
         primary: 'Quiero elegir el formato' },
    3: { title: 'Las medidas garantizan un proyecto a medida',
         sub:   'Con las medidas de tu cuarto, te sugerimos el placard que mejor aprovecha el espacio.',
         primary: 'Quiero indicar las medidas' },
    4: { title: 'La cama define todo el layout del cuarto',
         sub:   'Saber el tamaño de la cama nos ayuda a planificar la mejor distribución de los muebles.',
         primary: 'Quiero indicar la cama' },
    5: { title: 'Armemos el ambiente completo',
         sub:   'Elegir los muebles complementarios acerca el proyecto a lo que imaginás.',
         primary: 'Quiero elegir los muebles' },
    6: { title: 'Entender tu plazo agiliza la atención',
         sub:   'Saber si el espacio ya está listo nos ayuda a organizar el mejor momento para hablar con vos.',
         primary: 'Quiero responder' },
    7: { title: 'Te hablamos en el momento justo',
         sub:   'Si nos decís cuándo pensás comprar, te contactamos cerca de la fecha ideal.',
         primary: 'Quiero indicar la fecha' },
    8: { title: 'Te sugerimos opciones dentro de tu presupuesto',
         sub:   'Saber cuánto pensás invertir nos ayuda a presentarte las mejores opciones.',
         primary: 'Quiero indicar el monto' }
  };

  // Campos ocultos fixos (existem na definição do form; sempre enviados)
  //
  // ⚠ ATUALIZAÇÃO (jul/2026) — ANTI-SOBRESCRITA:
  // origem_de_cadastro / origem_de_cadastro__crm_ deixaram de ser enviadas
  // DIRETO pelo formulário. O motivo: toda submissão da Forms API SOBRESCREVE
  // essas propriedades no contato, então quem já tinha uma origem registrada
  // (de outro formulário/página) perdia esse histórico ao preencher o Quiz NEO.
  //
  // Solução (staging property + workflow, já usada no LP-NEO/Mês da Cozinha):
  //   1. Criadas 2 propriedades novas, mesmo tipo das originais:
  //        origem_de_cadastro_staging
  //        origem_de_cadastro__crm__staging
  //   2. Essas 2 propriedades estão adicionadas como CAMPOS no form 980a0b88.
  //   3. Um workflow no HubSpot (gatilho: submissão deste form OU propriedade
  //      staging alterada) copia o valor da staging pra propriedade ORIGINAL
  //      usando a ação "adicionar valor" (não "definir/sobrescrever"), e depois
  //      limpa a staging.
  // Resultado: a propriedade original agora ACUMULA os valores em vez de
  // perder o que já existia. NÃO reverta isso para os nomes antigos sem
  // desativar o workflow correspondente, senão volta a sobrescrever.
  //
  // ⚠ ARGENTINA: `nacionalidade` = "Argentina" é o que separa os leads
  // argentinos dos brasileiros, já que os dois usam o MESMO formulário.
  // A propriedade precisa ter a opção "Argentina" E estar adicionada como
  // CAMPO no form 980a0b88 — senão a Forms API descarta em silêncio
  // (status 200, dado perdido) e você só descobre semanas depois.
  var HIDDEN_FIELDS = [
    { name: 'nacionalidade',                             value: 'Argentina' },
    { name: 'qual_a_linha_que_voce_gostou_mais_',        value: 'Neo' },
    { name: 'origem_de_cadastro_staging',                value: 'LP GR Modulado (Quiz)' },
    { name: 'origem_de_cadastro__crm__staging',          value: 'LP GR Modulado (Quiz)' },
    { name: 'madesa_email_consent',                      value: 'true' },
    // Propriedade 'fuente_de_registro__mexico_' — rótulo real:
    // "Fuente de registro (LATAM)". O nome interno cita México por histórico.
    { name: 'fuente_de_registro__mexico_',               value: 'Quiz NEO' }

    // ⚠ 'fuente_de_registro__argentina_' (rótulo "Shopify (Argentina)",
    //   único valor possível: "Shopify") NÃO está adicionada como CAMPO no
    //   form 980a0b88 — hoje a Forms API descartaria em silêncio. Adicione o
    //   campo no formulário e só então descomente a linha abaixo.
    // , { name: 'fuente_de_registro__argentina_',       value: 'Shopify' }
  ];

  // Consentimento LGPD nativo do form (bloco visto no hs_context).
  // ⚠ VALIDAR no envio de teste: se a API reclamar de legalConsentOptions,
  // é só remover este bloco (o form usa processingConsentType IMPLICIT).
  var LEGAL_CONSENT = {
    consent: {
      consentToProcess: true,
      text: 'Para poder brindarte nuestro servicio, necesitamos tu autorización para almacenar y procesar tus datos personales.',
      communications: [
        // ⚠ subscriptionTypeId é o mesmo do Brasil (mesmo portal). Se o
        // marketing criar um tipo de assinatura próprio para a Argentina,
        // troque o número aqui.
        { value: true, subscriptionTypeId: 2924505825, text: 'Acepto recibir otras comunicaciones de Madesa.' }
      ]
    }
  };

  var MSG = {
    required:   'Por favor, completá este campo para continuar.',
    email:      'Ingresá un e-mail válido.',
    phone:      'Ingresá un teléfono válido: código de área + número.',
    pickOne:    'Seleccioná una opción para continuar.',
    pickMany:   'Seleccioná al menos una opción para continuar.',
    consent:    'Es necesario aceptar para continuar.',
    fileTooBig: 'Uno de los archivos supera los ' + MAX_FILE_MB + 'MB. Elegí un archivo más chico.',
    submitting: 'Enviando...',
    error:      'No pudimos enviar el formulario ahora. Probá de nuevo en unos instantes.'
  };

  // Rótulos do botão principal (footer), por estado.
  var BTN = {
    start:  'Comenzar',
    next:   'Continuar',
    skip:   'Saltar',
    submit: 'Enviar'
  };

  // Etapa 3 (medidas): campo do formato (etapa 2) -> nº de paredes a medir
  var FORMAT_FIELD = 'que_formato_de_placard_se_adapta_mejor_a_tu_espacio_arneo';
  var FORMAT_WALLS = { 'Lineal': 1, 'De esquina': 2, 'Paralelo': 2, 'En U': 3, 'Otro formato': 1 };

  function isEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

// TELEFONE ARGENTINO
// O prefixo "+54 9 " é fixo e a máscara só cuida do que vem depois dele
// (código de área + número = 10 dígitos).
//
// Por que o "9": no formato internacional, celular argentino é
// +54 9 <área> <número>. Sem esse 9 o número NÃO abre no WhatsApp — e o
// quiz promete contato por WhatsApp. Se algum dia o time passar a receber
// muito telefone fixo, basta trocar PHONE_PREFIX para '+54 '.
//
// A máscara também limpa sozinha o que o argentino costuma digitar por
// hábito e não vale no formato internacional: o "0" do interurbano e o
// "15" do celular (ex.: "011 15-2345-6789" vira "11 2345-6789").
function formatPhoneAR(afterPrefix) {
  var digits = (afterPrefix || '').replace(/\D/g, '');

  if (digits.indexOf('54') === 0 && digits.length > 10) digits = digits.slice(2); // colou o país junto
  if (digits.charAt(0) === '0') digits = digits.slice(1);                          // 0 do interurbano
  if (digits.length === 11 && digits.charAt(0) === '9') digits = digits.slice(1);  // 9 repetido

  // "15" do celular, logo depois do código de área (2, 3 ou 4 dígitos).
  // Só entra quando sobram 12 dígitos, que é exatamente área + 15 + número:
  // tirando o "15" fecha nos 10 dígitos do formato internacional.
  if (digits.length === 12) {
    for (var k = 2; k <= 4; k++) {
      if (digits.substr(k, 2) === '15') { digits = digits.slice(0, k) + digits.slice(k + 2); break; }
    }
  }

  digits = digits.slice(0, 10);               // área + número = sempre 10 dígitos

  // Só o 11 (AMBA) tem código de área de 2 dígitos; o resto é 3 (ou 4, raro).
  // Isso afeta SÓ a exibição — o valor gravado na HubSpot é só dígitos.
  var areaLen = (digits.indexOf('11') === 0) ? 2 : 3;
  var area = digits.slice(0, areaLen);
  var rest = digits.slice(areaLen);
  var out = area;
  if (rest) {
    out += ' ';
    if (rest.length <= 4) out += rest;
    else out += rest.slice(0, rest.length - 4) + '-' + rest.slice(-4);
  }
  return out;
}

var PHONE_PREFIX = '+54 9 ';
// Dígitos mínimos do campo INTEIRO (prefixo + número): "549" + 10 = 13.
// Sem isso, o prefixo fixo sozinho já contava como "campo preenchido" e
// liberava o botão Continuar — bug herdado da versão brasileira.
var PHONE_MIN_DIGITS = 13;
function isPhoneFilled(v) { return (v || '').replace(/\D/g, '').length >= PHONE_MIN_DIGITS; }

  function getHutk() {
    var m = document.cookie.match(/(^|;\s*)hubspotutk=([^;]*)/);
    return m ? m[2] : '';
  }

  // Formata bytes em B/KB/MB pro item da lista de arquivos.
  function formatFileSize(bytes) {
    if (!bytes && bytes !== 0) return '';
    if (bytes < 1024) return bytes + ' B';
    var kb = bytes / 1024;
    if (kb < 1024) return Math.round(kb) + ' KB';
    return (kb / 1024).toFixed(1) + ' MB';
  }

  // ---------------------------------------------------------------------
  // UPLOAD DE ARQUIVO (etapa 3) — form dedicado + iframe oculto (v2 legado)
  // ---------------------------------------------------------------------
  // Cria (ou reaproveita) o iframe oculto que recebe o POST do upload. O
  // iframe tem ID FIXO e NUNCA é removido — ele é o target do POST, e
  // destruí-lo antes da HubSpot terminar interrompe o upload.
  //
  // ⚠ Por que esperar o primeiro "load": um iframe recém-criado dispara um
  // "load" do próprio about:blank. Se a gente escutasse o load logo depois do
  // form.submit(), esse evento fantasma seria confundido com "a HubSpot
  // respondeu" — e o redirect sairia no meio do upload. Esperando o load
  // inicial ANTES de montar o form, o próximo load é, com certeza, a resposta.
  var UPLOAD_IFRAME_NAME = 'mnq-file-upload-frame';

  function ensureUploadFrame() {
    return new Promise(function (resolve) {
      var existing = document.getElementById(UPLOAD_IFRAME_NAME);
      if (existing) { resolve(existing); return; }

      var iframe = document.createElement('iframe');
      iframe.name = UPLOAD_IFRAME_NAME;
      iframe.id = UPLOAD_IFRAME_NAME;
      iframe.style.display = 'none';

      var settled = false;
      var done = function () { if (!settled) { settled = true; resolve(iframe); } };

      iframe.addEventListener('load', function onFirstLoad() {
        iframe.removeEventListener('load', onFirstLoad);
        done();
      });
      window.setTimeout(done, 1000); // fallback: navegador que não dispare o load inicial

      document.body.appendChild(iframe);
    });
  }

  // Sobe o(s) arquivo(s) da etapa 3 pro form DEDICADO (só email + arquivo_neo),
  // via endpoint v2 legado, usando um <form>+<iframe> escondidos em vez de
  // fetch — contorna CORS porque não é uma chamada AJAX, é um POST de
  // formulário tradicional. Não dá pra LER a resposta (Same-Origin Policy),
  // mas dá pra SABER que ela chegou, pelo evento "load" do iframe — é isso que
  // segura o redirect até o upload terminar (item 6).
  //
  // Retorna uma Promise que resolve quando o iframe responde OU quando estoura
  // FILE_UPLOAD_WAIT_MS. Ela NUNCA rejeita: continua best-effort por design.
  // TUDO aqui dentro fica protegido por try/catch — uma falha (ex.: navegador
  // sem suporte a DataTransfer) só é logada e NUNCA impede o envio principal
  // do quiz (v3) de acontecer.
  function submitFileViaHiddenIframe(email, files) {
    if (!files || !files.length) return Promise.resolve();

    return new Promise(function (resolve) {
      var done = false;
      function finish() { if (!done) { done = true; resolve(); } }

      // Teto global: mesmo que nada responda, o redirect não fica preso.
      window.setTimeout(finish, FILE_UPLOAD_WAIT_MS);

      try {
        ensureUploadFrame().then(function (iframe) {
          try {
            var form = document.createElement('form');
            form.action = LEGACY_FILE_UPLOAD_URL;
            form.method = 'POST';
            form.enctype = 'multipart/form-data';
            form.target = UPLOAD_IFRAME_NAME;
            form.style.display = 'none';

            var emailInput = document.createElement('input');
            emailInput.type = 'hidden';
            emailInput.name = 'email';
            emailInput.value = email || '';
            form.appendChild(emailInput);

            var ctxInput = document.createElement('input');
            ctxInput.type = 'hidden';
            ctxInput.name = 'hs_context';
            ctxInput.value = JSON.stringify({
              pageUri: window.location.href,
              pageName: document.title,
              hutk: getHutk()
            });
            form.appendChild(ctxInput);

            // Precisa ser um <input type="file"> real; usamos DataTransfer pra
            // transferir os File objects já escolhidos pelo usuário na etapa 3.
            var fileInput = document.createElement('input');
            fileInput.type = 'file';
            fileInput.name = FILE_FIELD;
            fileInput.multiple = true;
            var dt = new DataTransfer();
            Array.prototype.forEach.call(files, function (f) { dt.items.add(f); });
            fileInput.files = dt.files;
            form.appendChild(fileInput);

            // "load" agora = resposta da HubSpot ao POST (ver ensureUploadFrame).
            var onLoad = function () {
              iframe.removeEventListener('load', onLoad);
              finish();
            };
            iframe.addEventListener('load', onLoad);

            document.body.appendChild(form);
            form.submit();
            window.setTimeout(function () { form.remove(); }, 30000); // 30s: margem p/ upload em conexão mais lenta
          } catch (err) {
            console.error('[NEO Quiz] Falha ao tentar enviar arquivo via iframe oculto — quiz principal segue normalmente.', err);
            finish();
          }
        });
      } catch (err) {
        // Best-effort de verdade: qualquer falha aqui é só logada — o envio
        // principal do quiz (v3) já rodou/vai rodar normalmente de qualquer forma.
        console.error('[NEO Quiz] Falha ao preparar o iframe de upload — quiz principal segue normalmente.', err);
        finish();
      }
    });
  }

  // -------------------------------------------------------------------
  // INIT
  // -------------------------------------------------------------------
  function init(root) {
    var modal = (root || document).querySelector('[data-mnq-modal]');
    if (!modal || modal.dataset.mnqInit === 'true') return;
    modal.dataset.mnqInit = 'true';

    var body      = document.body;
    var overlay   = document.querySelector('[data-mnq-overlay]');
    var header    = modal.querySelector('.mnq-header');
    var backBtn   = modal.querySelector('[data-mnq-back]');
    var nextBtn   = modal.querySelector('[data-mnq-next]');
    var progress  = modal.querySelector('[data-mnq-progress]');
    var progText  = modal.querySelector('[data-mnq-progress-text]');
    var progFill  = modal.querySelector('[data-mnq-progress-fill]');
    var statusEl  = modal.querySelector('[data-mnq-status]');
    var footer    = modal.querySelector('.mnq-footer');

    // Itens 2/3/4: refs do card de confirmação (fica FORA de .mnq-card, mas
    // dentro de [data-mnq-modal], então este querySelector encontra).
    var confirmEl   = modal.querySelector('[data-mnq-confirm]');
    var cfTitle     = modal.querySelector('[data-confirm-title]');
    var cfSub       = modal.querySelector('[data-confirm-sub]');
    var cfPrimary   = modal.querySelector('[data-confirm-primary]');
    var cfPrimaryLb = modal.querySelector('[data-confirm-primary-label]');
    var cfSkip      = modal.querySelector('[data-confirm-skip]');
    var cfExit      = modal.querySelector('[data-confirm-exit]');

    var steps = Array.prototype.slice.call(modal.querySelectorAll('.mnq-step'));
    var isQuestion = function (s) { return s.dataset.stepKind === 'question'; };
    var questions = steps.filter(isQuestion);
    var totalQ = questions.length;         // 8 etapas de pergunta
    var current = 0;                       // índice em `steps`

    function successIndex() {
      return steps.findIndex(function (s) { return s.dataset.stepKind === 'success'; });
    }

    // Etapa 7 (data): só permite o mês atual em diante (bloqueia meses passados
    // na própria grade nativa do navegador via atributo "min").
    var monthInput = modal.querySelector('input[type="month"][data-hs-field]');
    if (monthInput) {
      var now = new Date();
      var mm = String(now.getMonth() + 1).padStart(2, '0');
      monthInput.min = now.getFullYear() + '-' + mm;          // mês atual em diante
      monthInput.max = (now.getFullYear() + 1) + '-12';       // até dezembro do ano que vem
    }

    // ---- abertura / fechamento ----
    function scrollbarW() { return window.innerWidth - document.documentElement.clientWidth; }

    function open(e) {
      if (e) e.preventDefault();
      overlay.hidden = false; modal.hidden = false;
      void modal.offsetWidth;
      var sb = scrollbarW(); if (sb > 0) body.style.paddingRight = sb + 'px';
      body.classList.add('mnq-open');
      overlay.classList.add('is-open');
      modal.classList.add('is-open');
      hideConfirm(); // garante que o card de confirmação nunca abra junto
      // Reabertura: se já enviou nesta sessão de página, volta direto pra tela
      // de sucesso. Senão, RETOMA na etapa em que o usuário parou (as respostas
      // já preenchidas continuam no DOM, pois fechar só esconde o modal — não
      // reseta os campos). Na primeira abertura `current` é 0 (boas-vindas),
      // então começa do início normalmente.
      if (submitted) {
        var si = successIndex();
        goTo(si > -1 ? si : 0);
      } else {
        goTo(current);
      }
    }
    function close() {
      hideConfirm();
      overlay.classList.remove('is-open');
      modal.classList.remove('is-open');
      body.classList.remove('mnq-open');
      body.style.paddingRight = '';
      window.setTimeout(function () { modal.hidden = true; overlay.hidden = true; }, 320);
    }

    // ---- status ----
    function showStatus(msg) {
      if (!statusEl) return;
      statusEl.hidden = false;
      statusEl.textContent = msg;
    }
    function clearStatus() {
      if (!statusEl) return;
      statusEl.hidden = true; statusEl.textContent = '';
    }

    // ---- navegação ----
    function questionIndexOf(stepEl) {
      return questions.indexOf(stepEl); // 0-based entre as perguntas
    }
    // qi da etapa atual (1-based entre as perguntas). 0 se não for pergunta.
    function currentQi() {
      var step = steps[current];
      return (step && step.dataset.stepKind === 'question') ? questionIndexOf(step) + 1 : 0;
    }

    function render() {
      var step = steps[current];
      var kind = step.dataset.stepKind; // welcome | question | success

      steps.forEach(function (s) { s.classList.toggle('is-active', s === step); });
      hideConfirm(); // trocou de etapa -> nunca deixa o card de confirmação preso

      // header: progresso + voltar + alinhamento da logo
      var isQ = kind === 'question';
      header.classList.toggle('is-step', isQ);
      if (progress) progress.hidden = !isQ;
      // voltar é controlado pelo CSS (.mnq-header.is-step .mnq-back) para manter
      // o espaçador de 48px na welcome e centralizar a logo, como no Figma.

      if (isQ) {
        var qi = questionIndexOf(step) + 1; // 1-based
        if (progText) progText.textContent = qi + ' de ' + totalQ;
        if (progFill) progFill.style.width = Math.round((qi / totalQ) * 100) + '%';
      }

      // rótulo do botão
      var label = BTN.next;
      if (kind === 'welcome') label = BTN.start;
      else if (kind === 'question' && questionIndexOf(step) === totalQ - 1) label = BTN.submit;
      if (nextBtn) {
        nextBtn.querySelector('[data-mnq-next-label]').textContent = label;
        nextBtn.classList.remove('mnq-btn--outline');
      }

      // etapa de medidas: monta paredes/diagrama conforme o formato escolhido
      var isMedidas = step.hasAttribute('data-step-medidas');
      if (isMedidas) setupMedidas(step);
      // grupos de radio opcionais (ex.: etapa da cama): Pular/Avançar dinâmico
      var isOptional = !!step.querySelector('[data-optional-radio]');
      if (isOptional) updateOptionalRadioLabel(step);
      // etapas obrigatórias sem Pular (formato, espaço, valor, dados, data,
      // consentimento): botão nasce desabilitado/cinza até responder — igual Figma.
      if (!isMedidas && !isOptional) updateRequiredButtonState(step);

      // footer some na tela de sucesso
      if (footer) footer.hidden = (kind === 'success');

      clearStatus();
    }

    // ---- reflete se a etapa obrigatória já foi respondida no botão Avançar ----
    function isStepAnswered(step) {
      var groups = step.querySelectorAll('[data-hs-required="true"]');
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var type = g.getAttribute('data-hs-group') || '';
        if (type === 'radio' || type === 'checkbox') {
          if (g.querySelectorAll('input:checked').length === 0) return false;
        } else if (type === 'consent') {
          var c = g.querySelector('input[type="checkbox"]');
          if (!c || !c.checked) return false;
        } else {
          var input = g.querySelector('input, textarea, select');
          var val = (input && input.value ? input.value : '').trim();
          if (!val) return false;
          if (input.type === 'email' && !isEmail(val)) return false;
          if (input.type === 'tel' && !isPhoneFilled(val)) return false;
        }
      }
      return true;
    }
    function updateRequiredButtonState(step) {
      if (!nextBtn) return;
      var hasRequired = step.querySelectorAll('[data-hs-required="true"]').length > 0;
      if (!hasRequired) { nextBtn.disabled = false; nextBtn.classList.remove('mnq-btn--disabled'); return; }
      var ok = isStepAnswered(step);
      nextBtn.disabled = !ok;
      nextBtn.classList.toggle('mnq-btn--disabled', !ok);
    }

    // ---- grupos de radio opcionais (ex.: etapa da cama): Pular/Avançar ----
    function updateOptionalRadioLabel(step) {
      var grp = step.querySelector('[data-optional-radio]');
      if (!grp) return;
      var checked = grp.querySelector('input:checked');
      var lbl = nextBtn.querySelector('[data-mnq-next-label]');
      if (checked) {
        lbl.textContent = (questionIndexOf(step) === totalQ - 1) ? BTN.submit : BTN.next;
        nextBtn.classList.remove('mnq-btn--outline');
      } else {
        lbl.textContent = BTN.skip;
        nextBtn.classList.add('mnq-btn--outline');
      }
    }

    // ---- etapa 3: medidas das paredes (dinâmica) ----
    function getSelectedFormat() {
      var r = modal.querySelector('input[data-hs-field="' + FORMAT_FIELD + '"]:checked');
      return r ? r.value : '';
    }
    function setupMedidas(step) {
      var fmt = getSelectedFormat();
      var isOther = (fmt === 'Otro formato');
      var walls = isOther ? 0 : (FORMAT_WALLS[fmt] || 1);

      step.querySelectorAll('[data-diag]').forEach(function (d) {
        d.hidden = isOther || (d.getAttribute('data-diag') !== fmt);
      });
      step.querySelectorAll('[data-wall]').forEach(function (w) {
        w.hidden = isOther || (+w.getAttribute('data-wall') > walls);
      });
      // "Otro formato": some com a área de diagrama+medidas por inteiro,
      // deixando visível apenas o bloco de upload de imagem.
      var medidasBlock = step.querySelector('.mnq-medidas');
      if (medidasBlock) medidasBlock.hidden = isOther;

      // Título muda para "Anexe..." quando não há medida numérica (Otro formato).
      var titleEl = step.querySelector('[data-medidas-title]');
      if (titleEl) {
        titleEl.textContent = isOther
          ? 'Adjuntá acá la medida de tu espacio'
          : '¿Cuál es la medida de tu espacio?';
      }

      // Formato mudou -> paredes escondidas não podem deixar valor residual
      // dentro do campo concatenado (senão iria junto no submit).
      syncMeasures(step);
      updateMedidasLabel(step);
    }
    function updateMedidasLabel(step) {
      var fmt = getSelectedFormat();
      var isOther = (fmt === 'Otro formato');
      var hasFile = uploadFiles.length > 0;
      var lbl = nextBtn.querySelector('[data-mnq-next-label]');

      if (isOther) {
        // "Otro formato": sem medida numérica de fallback, então o upload
        // de imagem passa a ser obrigatório (Avançar nasce desabilitado,
        // sem opção de Pular) — conforme o Figma mobile do caso "Outro".
        lbl.textContent = BTN.next;
        nextBtn.classList.remove('mnq-btn--outline');
        nextBtn.disabled = !hasFile;
        nextBtn.classList.toggle('mnq-btn--disabled', !hasFile);
        return;
      }

      nextBtn.disabled = false;
      nextBtn.classList.remove('mnq-btn--disabled');
      var filled = hasFile;
      step.querySelectorAll('[data-wall]').forEach(function (w) {
        if (w.hidden) return;
        var inp = w.querySelector('[data-wall-input]');
        if (inp && inp.value.trim()) filled = true;
      });
      if (filled) { lbl.textContent = BTN.next; nextBtn.classList.remove('mnq-btn--outline'); }
      else { lbl.textContent = BTN.skip; nextBtn.classList.add('mnq-btn--outline'); }
    }

    // Concatena as paredes num ÚNICO campo de texto da HubSpot
    // (MEASURES_FIELD), no formato: "Pared 1: 300 cm | Pared 2: 250 cm".
    // Só entram paredes VISÍVEIS (aplicáveis ao formato escolhido) e
    // PREENCHIDAS. Sem nenhuma medida, o campo fica vazio e buildFields()
    // simplesmente não o envia.
    function syncMeasures(step) {
      var parts = [];
      step.querySelectorAll('[data-wall]').forEach(function (w) {
        if (w.hidden) return;
        var inp = w.querySelector('[data-wall-input]');
        var val = inp ? (inp.value || '').trim() : '';
        if (!val) return;
        var labelEl = w.querySelector('.mnq-wall__label');
        var label = labelEl
          ? labelEl.textContent.replace(/[:\s]+$/, '').trim()
          : ('Pared ' + w.getAttribute('data-wall'));
        parts.push(label + ': ' + val + ' cm');
      });
      var hid = step.querySelector('input[data-hs-field="' + MEASURES_FIELD + '"]');
      if (hid) hid.value = parts.join(' | ');
    }

    function goTo(i) {
      current = Math.max(0, Math.min(i, steps.length - 1));
      render();
    }

    function goBack() {
      if (current > 0) goTo(current - 1);
    }

    function goNext() {
      var step = steps[current];
      if (step.dataset.stepKind === 'question' && !validateStep(step)) return;

      // Item 1: captação do lead ao concluir a etapa de DADOS (1ª pergunta).
      // Best-effort e não bloqueia a navegação.
      if (step.dataset.stepKind === 'question' && questionIndexOf(step) === 0) {
        captureLead();
      }

      // última pergunta -> submit
      var isLastQuestion = step.dataset.stepKind === 'question'
        && questionIndexOf(step) === totalQ - 1;
      if (isLastQuestion) { submit(); return; }

      goTo(current + 1);
    }

    // ---- validação da etapa ----
    function validateStep(step) {
      clearStatus();
      var groups = step.querySelectorAll('[data-hs-required="true"]');
      for (var i = 0; i < groups.length; i++) {
        var g = groups[i];
        var type = g.getAttribute('data-hs-group') || '';

        if (type === 'radio' || type === 'checkbox') {
          var checked = g.querySelectorAll('input:checked').length;
          if (checked === 0) {
            showStatus(type === 'radio' ? MSG.pickOne : MSG.pickMany);
            g.scrollIntoView({ block: 'center', behavior: 'smooth' });
            return false;
          }
        } else if (type === 'consent') {
          var c = g.querySelector('input[type="checkbox"]');
          if (!c || !c.checked) { showStatus(MSG.consent); return false; }
        } else {
          var input = g.querySelector('input, textarea, select');
          var val = (input && input.value ? input.value : '').trim();
          if (!val) { showStatus(MSG.required); input && input.focus(); return false; }
          if (input.type === 'email' && !isEmail(val)) { showStatus(MSG.email); input.focus(); return false; }
          if (input.type === 'tel' && !isPhoneFilled(val)) { showStatus(MSG.phone); input.focus(); return false; }
        }
      }
      return true;
    }

    // ---- coleta de valores ----
    function collect() {
      var out = {};
      modal.querySelectorAll('[data-hs-field]').forEach(function (el) {
        var name = el.getAttribute('data-hs-field');
        if (el.type === 'checkbox') {
          if (!out[name]) out[name] = [];
          if (el.checked) out[name].push(el.value);
        } else if (el.type === 'radio') {
          if (el.checked) out[name] = el.value;
        } else {
          out[name] = el.value;
        }
      });
      return out;
    }

    // `extra` (opcional): lista de { name, value } acrescentada ao final —
    // usado para injetar a etapa de saída (item 5) sem mexer nos campos do form.
    function buildFields(extra) {
      var raw = collect();
      var fields = [];
      Object.keys(raw).forEach(function (name) {
        var v = raw[name];
        if (Array.isArray(v)) v = v.join(';');          // multi-checkbox -> "a;b;c"
        if (name === DATE_FIELD && v) {                  // data -> epoch ms (UTC)
          var p = v.split('-');                          // "YYYY-MM" (type=month) ou "YYYY-MM-DD"
          var d = p[2] ? +p[2] : 1;                      // sem dia (mês/ano) -> dia 1
          v = String(Date.UTC(+p[0], +p[1] - 1, d));
        }
        if (name === 'phone' && v) v = v.replace(/\D/g, ''); // só dígitos: "5491123456789" (o "549" já vem do prefixo fixo)
        if (v !== '' && v != null) fields.push({ name: name, value: String(v) });
      });
      HIDDEN_FIELDS.forEach(function (f) { fields.push(f); });
      if (extra) extra.forEach(function (f) {
        if (f && f.value !== '' && f.value != null) fields.push(f);
      });
      return fields;
    }

    // ---- POST genérico na Forms API (usado por captação, saída e final) ----
    // Retorna a Promise do fetch; lança erro em resposta !ok (com log). Quem
    // chama decide se surface o erro (final) ou só loga (best-effort).
    //
    // `opts.keepalive` (item 6): mantém o POST vivo mesmo se a página navegar
    // logo depois. Usado na captação antecipada e no registro de saída, que
    // agora podem ser seguidos de um redirect para a página de gracias.
    // O payload é pequeno, bem abaixo do limite de 64KB do keepalive.
    function postToHubspot(fields, ipAddress, opts) {
      var ctx = { pageUri: window.location.href, pageName: document.title };
      var hutk = getHutk();
      if (hutk) ctx.hutk = hutk;      // só envia hutk se o cookie existir (API rejeita '')
      if (ipAddress) ctx.ipAddress = ipAddress;

      var payload = {
        fields: fields,
        context: ctx,
        legalConsentOptions: LEGAL_CONSENT
      };

      var reqInit = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      };
      if (opts && opts.keepalive) reqInit.keepalive = true;

      return fetch(SUBMIT_URL, reqInit).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (data) {
          if (!res.ok) {
            console.error('[NEO Quiz] Falha no envio', res.status, data);
            throw new Error((data && data.message) || MSG.error);
          }
          return data;
        });
      });
    }

    // ---- item 1: captação antecipada do lead (best-effort) ----
    // Ao avançar da etapa 1, só nome/e-mail/telefone estão preenchidos, então
    // buildFields() já devolve exatamente esses + os HIDDEN_FIELDS (origem,
    // linha, consentimento). Marca leadCaptured de forma otimista pra não
    // disparar duas vezes; uma falha de rede só é logada e não trava nada.
    function captureLead() {
      if (leadCaptured) return;
      leadCaptured = true;
      try {
        postToHubspot(buildFields(), '', { keepalive: true }).catch(function (err) {
          console.error('[NEO Quiz] Captação inicial do lead falhou (o quiz segue normalmente).', err);
        });
      } catch (err) {
        console.error('[NEO Quiz] Erro inesperado na captação inicial do lead.', err);
      }
    }

    // ---- item 5: registra a etapa de saída + campos já preenchidos ----
    // Best-effort: dispara e fecha. Vai com keepalive porque, desde o item 6,
    // logo depois disso a página navega para a URL de gracias — sem keepalive
    // o navegador cancelaria este POST no meio.
    function recordExit(stepValue) {
      try {
        var medStep = modal.querySelector('[data-step-medidas]');
        if (medStep) syncMeasures(medStep); // garante o campo de medidas atualizado
        postToHubspot(buildFields([{ name: EXIT_FIELD, value: stepValue }]), '', { keepalive: true })
          .catch(function (err) {
            console.error('[NEO Quiz] Registro da etapa de saída falhou.', err);
          });
      } catch (err) {
        console.error('[NEO Quiz] Erro inesperado ao registrar etapa de saída.', err);
      }
    }

    // -------------------------------------------------------------------
    // ITENS 2/3/4 — CARD DE CONFIRMAÇÃO POR ETAPA (ao tentar FECHAR)
    // -------------------------------------------------------------------
    function showConfirm(qi) {
      var copy = CARD_COPY[qi];
      if (!copy || !confirmEl) { close(); return; }        // sem conteúdo -> fecha direto
      if (cfTitle)     cfTitle.textContent = copy.title;
      if (cfSub)       cfSub.textContent = copy.sub;
      if (cfPrimaryLb) cfPrimaryLb.textContent = copy.primary;
      confirmEl.hidden = false;
      confirmEl.classList.add('is-open');
    }
    function hideConfirm() {
      if (!confirmEl) return;
      confirmEl.classList.remove('is-open');
      confirmEl.hidden = true;
    }

    // Ponto único de "pedido de fechamento": nas etapas 2 a 8 abre o card de
    // confirmação; nas demais (welcome, etapa 1, sucesso) fecha direto.
    function requestClose() {
      var step = steps[current];
      var qi = currentQi();

      // Tela de sucesso ("Seguir navegando"): o redirect do item 6 já foi
      // agendado pelo submit(). Se ele existe, antecipamos; se ainda NÃO
      // existe, é porque o upload do arquivo está em andamento — nesse caso
      // não navegamos aqui, para não cancelar o upload: o fluxo normal leva
      // pra página de gracias assim que ele terminar.
      if (step && step.dataset.stepKind === 'success') {
        close();
        if (redirecting) goToThankYou(0, true);
        return;
      }

      if (qi >= 2) { showConfirm(qi); return; }

      // Boas-vindas (qi 0) e etapa de dados (qi 1): fecham direto. Por padrão
      // (REDIRECT_ON_CLOSE_MIN_QI = 2) não redirecionam, porque aqui ainda não
      // existe lead — mandar essa pessoa pra página de gracias contaria uma
      // conversão que não aconteceu. Ponha 0 na constante para redirecionar
      // em qualquer fechamento.
      close();
      if (qi >= REDIRECT_ON_CLOSE_MIN_QI) goToThankYou(0);
    }

    // "Pular esta pergunta": pula SÓ a pergunta atual e segue no formulário.
    // Não grava etapa de saída (a pessoa continua no quiz) e não redireciona.
    function skipQuestion() {
      hideConfirm();
      var step = steps[current];
      var isLast = step.dataset.stepKind === 'question' && questionIndexOf(step) === totalQ - 1;
      if (isLast) { submit(); return; }   // pular a última = concluir/enviar
      goTo(current + 1);
    }

    // "Sair do formulário": grava a etapa atual em etapa_de_saida_do_quiz_neo
    // (com os campos já preenchidos), fecha e leva pra página de gracias.
    // O POST vai com keepalive (sobrevive à navegação); os 250 ms são só a
    // folga para ele entrar na fila de rede antes de o browser navegar.
    function confirmExit() {
      var qi = currentQi();
      hideConfirm();
      recordExit(EXIT_STEP[qi] || '');
      close();
      goToThankYou(250);
    }

    // ---- envio (final) ----
    function submit() {
      clearStatus();

      // Trava de envio único: se já enviou nesta sessão, não reenvia — só
      // mostra a tela de sucesso de novo.
      if (submitted) {
        var siAlready = successIndex();
        if (siAlready > -1) goTo(siAlready);
        return;
      }

      // Valida tamanho do(s) arquivo(s) da etapa 3 antes de qualquer coisa
      // (limite documentado da HubSpot pro campo de arquivo).
      if (uploadInput && uploadInput.files && uploadInput.files.length) {
        var oversized = Array.prototype.some.call(uploadInput.files, function (f) {
          return f.size > MAX_FILE_MB * 1024 * 1024;
        });
        if (oversized) { showStatus(MSG.fileTooBig); return; }
      }

      // Dispara o envio do arquivo em paralelo, pro form dedicado — best-effort,
      // protegido por try/catch: NUNCA pode impedir o envio principal (v3) abaixo.
      // `filePromise` resolve quando o upload responde (ou estoura o teto) e é o
      // que segura o redirect do item 6 até o arquivo ter subido.
      var filePromise = null;
      var emailField = modal.querySelector('[data-hs-field="email"]');
      if (uploadInput && uploadInput.files && uploadInput.files.length) {
        try {
          filePromise = submitFileViaHiddenIframe(emailField ? emailField.value : '', uploadInput.files);
        } catch (err) {
          console.error('[NEO Quiz] Erro inesperado ao disparar upload de arquivo.', err);
        }
      }

      nextBtn.disabled = true;
      nextBtn.querySelector('[data-mnq-next-label]').textContent = MSG.submitting;

      var finish = function () {
        nextBtn.disabled = false;
        render();
      };

      // IP best-effort (não bloqueia)
      var getIp = fetch('https://api.ipify.org?format=json')
        .then(function (r) { return r.json(); })
        .then(function (d) { return d.ip; })
        .catch(function () { return ''; });

      // sincroniza as medidas (etapa 3 -> campo concatenado) antes do payload
      var medStep = modal.querySelector('[data-step-medidas]');
      if (medStep) syncMeasures(medStep);

      getIp.then(function (ip) {
        // Item 5: envio final marca a etapa de saída como "Concluído".
        return postToHubspot(buildFields([{ name: EXIT_FIELD, value: 'Concluído' }]), ip);
      })
      .then(function () {
        // Só marca como enviado APÓS sucesso confirmado — assim uma falha
        // permite tentar de novo, mas um sucesso trava novos envios.
        submitted = true;
        try {
          window.dispatchEvent(new CustomEvent('mnq:submitted', { detail: { formId: FORM_ID } }));
        } catch (e) {}
        // vai pra tela de sucesso
        var si = successIndex();
        if (si > -1) goTo(si); else finish();

        // Item 6: redireciona pra página de gracias. Espera as DUAS coisas:
        //   • o upload do arquivo terminar (navegar antes cancela o POST);
        //   • o tempo mínimo de tela de sucesso, que também dá folga pras
        //     tags de conversão dispararem.
        var waitUpload = filePromise || Promise.resolve();
        var minDelay = new Promise(function (r) { window.setTimeout(r, SUCCESS_REDIRECT_DELAY_MS); });
        var go = function () { goToThankYou(0); };
        Promise.all([waitUpload, minDelay]).then(go, go);
      })
      .catch(function (err) {
        showStatus(err.message || MSG.error);
        finish();
      });
    }

    // ---- listeners ----
    // GATILHOS DE ABERTURA — dois caminhos, o mesmo padrão do quiz da cozinha
    // (modal-projeto-ar.js), para não ter duas convenções na mesma loja:
    //
    //   1. class="js-madesa-popup-open" em qualquer elemento — para markup
    //      que a gente controla.
    //   2. um link cujo href seja uma das hashes abaixo — para sections cujo
    //      botão é montado a partir das settings e não aceita classe pelo
    //      editor de tema (na LP argentina: image-banner, neo-hero e
    //      ctas-videollamada). Basta colar a hash no campo de link do botão;
    //      nenhum arquivo precisa ser alterado, nem agora nem depois.
    //
    // Delegação no document para funcionar com botão renderizado depois
    // (carrossel, editor de tema, app block).
    //
    // ⚠ NÃO acrescente '#abrir-quiz' nem '#quiz-proyectos' nesta lista: são
    // do quiz da cozinha, que roda em TODAS as páginas. Um clique abriria os
    // dois modais ao mesmo tempo.
    var OPEN_HASHES = ['#abrir-quiz-neo', '#quiz-neo'];

    function isHashTrigger(el) {
      if (!el) return false;
      // getAttribute pega o valor cru ("#abrir-quiz-neo"); .hash pega o
      // fragmento já resolvido, caso o tema transforme em URL absoluta.
      var raw = (el.getAttribute && el.getAttribute('href')) || '';
      var hash = el.hash || '';
      return OPEN_HASHES.some(function (h) {
        return hash === h || raw === h || raw.slice(-h.length) === h;
      });
    }

    document.addEventListener('click', function (e) {
      if (!(e.target instanceof Element)) return;

      var classTrigger = e.target.closest('.js-madesa-popup-open');
      if (classTrigger) { e.preventDefault(); open(); return; }

      var linkTrigger = e.target.closest('a[href]');
      if (isHashTrigger(linkTrigger)) { e.preventDefault(); open(); }
    });
    // Item 4: todo pedido de fechamento passa por requestClose (nas etapas 2
    // a 8 isso abre o card de confirmação em vez de fechar direto). O botão
    // "Continuar navegando" da tela de sucesso também usa data-mnq-close, mas
    // como o sucesso não é pergunta, requestClose fecha direto nele.
    modal.querySelectorAll('[data-mnq-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); requestClose(); });
    });
    if (backBtn) backBtn.addEventListener('click', function (e) { e.preventDefault(); goBack(); });
    if (nextBtn) nextBtn.addEventListener('click', function (e) { e.preventDefault(); goNext(); });

    // Ações do card de confirmação
    if (cfPrimary) cfPrimary.addEventListener('click', function (e) { e.preventDefault(); hideConfirm(); }); // volta pra pergunta
    if (cfSkip)    cfSkip.addEventListener('click', function (e) { e.preventDefault(); skipQuestion(); });
    if (cfExit)    cfExit.addEventListener('click', function (e) { e.preventDefault(); confirmExit(); });
    // Clique no fundo escurecido do card = voltar pra pergunta (não fecha o form).
    if (confirmEl) confirmEl.addEventListener('click', function (e) { if (e.target === confirmEl) hideConfirm(); });

    // Etapas obrigatórias (sem Pular): reavalia o botão Avançar a cada resposta
    modal.querySelectorAll('[data-hs-required] input, [data-hs-required] textarea, [data-hs-required] select').forEach(function (el) {
      var reeval = function () {
        var st = el.closest('.mnq-step');
        if (st) updateRequiredButtonState(st);
      };
      el.addEventListener('input', reeval);
      el.addEventListener('change', reeval);
    });

    // Etapa 1: máscara de telefone argentina ao digitar
var phoneInput = modal.querySelector('[data-hs-field="phone"]');
if (phoneInput) {
  // Sempre começa com o prefixo fixo.
  if (!phoneInput.value || phoneInput.value.indexOf(PHONE_PREFIX) !== 0) {
    phoneInput.value = PHONE_PREFIX;
  }

  var applyPhoneMask = function () {
    var v = phoneInput.value;
    // Tudo que o usuário digitou é considerado "depois do +54 9 ".
    // Se por acaso o prefixo foi apagado/alterado, reconstruímos a partir
    // dos dígitos que sobraram (removendo o "54" e o "9" iniciais que sejam
    // resquício do próprio prefixo, não do código de área).
    var afterPrefix;
    if (v.indexOf(PHONE_PREFIX) === 0) {
      afterPrefix = v.slice(PHONE_PREFIX.length);
    } else {
      var d = v.replace(/\D/g, '');
      if (d.indexOf('54') === 0) d = d.slice(2);              // resquício do "+54"
      if (d.length === 11 && d.charAt(0) === '9') d = d.slice(1); // resquício do "9"
      afterPrefix = d;
    }
    phoneInput.value = PHONE_PREFIX + formatPhoneAR(afterPrefix);
  };

  phoneInput.addEventListener('input', applyPhoneMask);

  // Impede que o cursor apague/edite dentro do prefixo fixo "+54 9 ".
  phoneInput.addEventListener('keydown', function (e) {
    var pos = phoneInput.selectionStart;
    // Backspace no início do número (logo após o prefixo) não apaga o prefixo.
    if (e.key === 'Backspace' && pos <= PHONE_PREFIX.length &&
        phoneInput.selectionEnd <= PHONE_PREFIX.length) {
      e.preventDefault();
    }
  });

  // Se clicar dentro do prefixo, joga o cursor pro começo do número.
  phoneInput.addEventListener('focus', function () {
    if (phoneInput.value.length < PHONE_PREFIX.length) phoneInput.value = PHONE_PREFIX;
    var end = phoneInput.value.length;
    try { phoneInput.setSelectionRange(Math.max(PHONE_PREFIX.length, end), end); } catch (e) {}
  });
}

    // Grupos de radio opcionais (ex.: etapa da cama): atualiza Pular/Avançar ao selecionar
    modal.querySelectorAll('[data-optional-radio] input').forEach(function (inp) {
      inp.addEventListener('change', function () {
        var st = inp.closest('.mnq-step');
        if (st) updateOptionalRadioLabel(st);
      });
    });

    // Etapa 5 (móveis): "Todavía no lo sé" é exclusivo com os 6 cards de móveis.
    var furnGroup = modal.querySelector('[data-furniture-group]');
    if (furnGroup) {
      var furnCards = furnGroup.querySelector('.mnq-furncards');
      var noneInput = furnGroup.querySelector('[data-furn-none]');
      var furnInputs = furnGroup.querySelectorAll('[data-furn]');
      // marcar "Todavía no lo sé" -> desmarca e esmaece os 6 móveis
      if (noneInput) {
        noneInput.addEventListener('change', function () {
          if (noneInput.checked) {
            furnInputs.forEach(function (f) { f.checked = false; });
            if (furnCards) furnCards.classList.add('is-none-selected');
          } else {
            if (furnCards) furnCards.classList.remove('is-none-selected');
          }
        });
      }
      // marcar qualquer móvel -> desmarca "Todavía no lo sé" e remove o esmaecido
      furnInputs.forEach(function (f) {
        f.addEventListener('change', function () {
          if (f.checked && noneInput) {
            noneInput.checked = false;
            if (furnCards) furnCards.classList.remove('is-none-selected');
          }
        });
      });
    }

    // Etapa 3: campos de parede atualizam o rótulo do botão (Pular/Avançar) e as medidas
    modal.querySelectorAll('[data-wall-input]').forEach(function (inp) {
      inp.addEventListener('input', function () {
        var st = inp.closest('[data-step-medidas]');
        if (!st) return;
        syncMeasures(st);
        updateMedidasLabel(st);
      });
    });

    // Etapa 3: upload de imagem — lista os arquivos escolhidos, com nome,
    // tamanho e botão de remover por item. O envio de verdade só acontece
    // no submit() final, via submitFileViaHiddenIframe.
    //
    // uploadFiles é a FONTE DE VERDADE (array de File). Como <input
    // type="file" multiple"> REINICIA a seleção a cada escolha do usuário
    // (não soma sozinho), toda vez que o input dispara "change" a gente
    // ACRESCENTA os novos arquivos ao array e depois reconstrói
    // uploadInput.files via DataTransfer — assim uma nova escolha não
    // apaga os arquivos já anexados antes.
    var uploadInput = modal.querySelector('[data-upload]');
    var uploadFiles = [];

    function syncUploadInputFromArray() {
      if (!uploadInput) return;
      var dt = new DataTransfer();
      uploadFiles.forEach(function (f) { dt.items.add(f); });
      uploadInput.files = dt.files; // não dispara "change" — sem loop
    }

    function renderUploadList(step) {
      if (!step) return;
      var listEl = step.querySelector('[data-upload-list]');
      var nameEl = step.querySelector('[data-upload-name]');
      if (!listEl) return;

      listEl.innerHTML = '';

      if (!uploadFiles.length) {
        listEl.hidden = true;
        if (nameEl) nameEl.textContent = 'Ningún archivo seleccionado';
        return;
      }

      if (nameEl) {
        nameEl.textContent = uploadFiles.length === 1
          ? uploadFiles[0].name
          : uploadFiles.length + ' archivos seleccionados';
      }

      uploadFiles.forEach(function (file, idx) {
        var li = document.createElement('li');
        li.className = 'mnq-upload__item';

        var info = document.createElement('span');
        info.className = 'mnq-upload__item-info';

        var nameSpan = document.createElement('span');
        nameSpan.className = 'mnq-upload__item-name';
        nameSpan.textContent = file.name;

        var sizeSpan = document.createElement('span');
        sizeSpan.className = 'mnq-upload__item-size';
        sizeSpan.textContent = formatFileSize(file.size);

        info.appendChild(nameSpan);
        info.appendChild(sizeSpan);

        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'mnq-upload__item-remove';
        removeBtn.setAttribute('aria-label', 'Eliminar ' + file.name);
        removeBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>';
        removeBtn.addEventListener('click', function (e) {
          e.preventDefault();
          uploadFiles.splice(idx, 1);
          syncUploadInputFromArray();
          renderUploadList(step);
          updateMedidasLabel(step);
        });

        li.appendChild(info);
        li.appendChild(removeBtn);
        listEl.appendChild(li);
      });

      listEl.hidden = false;
    }

    if (uploadInput) uploadInput.addEventListener('change', function () {
      var st = uploadInput.closest('[data-step-medidas]');
      if (uploadInput.files && uploadInput.files.length) {
        Array.prototype.forEach.call(uploadInput.files, function (f) { uploadFiles.push(f); });
        syncUploadInputFromArray(); // reconstrói o input já ACUMULADO (sem disparar novo "change")
      }
      renderUploadList(st);
      updateMedidasLabel(st);
    });

    // Enter avança (exceto em textarea). Se o card de confirmação estiver
    // aberto, o Enter não avança a pergunta por baixo.
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
        e.preventDefault();
        if (confirmEl && confirmEl.classList.contains('is-open')) return;
        goNext();
      }
    });

    // Backdrop e ESC NÃO fecham (igual ao popup original).

    window.MadesaNeoQuiz = { open: open, close: close };
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();